import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PDR'

const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Authorize = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/authorize/${data.id}?observacao=${data.obs}`, data, config)
const Reject = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/reject`, data, config)
const SetNA = (pciObraID, data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/na/${pciObraID}`, data, config)
const Archive = (data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/Arquivar`, data, config)
const Delete = (data, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${data}`, config)
const GetPDRWorkAppraisalPDF = (obraMembroID) => APIClient.get(`${APIPci}/${resourceName}/avaliacao/pdf/${obraMembroID}`)
const PostCheckListChecked = (id, data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/checklist-checked/${id}`, data, config)
const GetPDRWorks = (data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/obras`, data, config)
const GetPDRTeam = (pdrObraId) => APIClient.get(`${APIPci}/${resourceName}/equipe/${pdrObraId}`)
const GetMontage = (id, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/montagem/${id}`, data, config)
const GetResumeXLS = (id) => APIClient.get(`${APIPci}/${resourceName}/downloadresumopdr/${id}`)
const GetCheckListBonus = (id, config) => APIClient.get(`${APIPci}/${resourceName}/checklist/${id}`, config)
const SetCheckListBonus = (id, data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/checklist/${id}`, data, config)
const PatchBuildObservation = (id, data, config = {}) => APIClient.patch(`${APIPci}/${resourceName}/ObservacaoMontagem/${id}`, data, config)
const SetCheckListBonusPartial = (id, data, config = {}) => APIClient.post(`${APIPci}/${resourceName}/checklist-partial/${id}`, data, config)

const PDRRepository = {
  Create,
  Authorize,
  Reject,
  SetNA,
  Delete,
  GetPDRWorkAppraisalPDF,
  GetPDRWorks,
  GetPDRTeam,
  GetMontage,
  Archive,
  GetResumeXLS,
  GetCheckListBonus,
  PostCheckListChecked,
  SetCheckListBonus,
  PatchBuildObservation,
  SetCheckListBonusPartial
}

export default PDRRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdr.js